import { OutlinedInput, Select, TextField } from '@mui/material';
import { styled } from '@mui/system';

export const StyledOutlinedInput = styled(OutlinedInput)(({ theme, disabled }) => ({
  '&&': {
    '& fieldset': {
      transition: theme.transitions.create('border-color'), // Smooth transition for border color
      borderColor: theme.palette.grey.dark, // Default border color
    },
    '&:hover fieldset': {
      borderColor: !disabled ? theme.palette.primary.main : theme.palette.grey.dark,
    },
    '&.Mui-focused fieldset': {
      borderColor: !disabled ? theme.palette.primary.main : theme.palette.grey.dark,
    },
  },
  borderRadius: 5,
  '&&&: before': {
    borderBottom: 'none',
  },
  '& input[type=number]': {
    '-moz-appearance': 'textfield',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));

export const StyledTextField = styled(TextField)(({ theme, disabled }) => ({
  '&&': {
    '& fieldset': {
      transition: theme.transitions.create('border-color'), // Smooth transition for border color
      borderColor: theme.palette.grey.dark, // Default border color
    },
    '&:hover fieldset': {
      borderColor: !disabled ? theme.palette.primary.main : theme.palette.grey.dark,
    },
    '&.Mui-focused fieldset': {
      borderColor: !disabled ? theme.palette.primary.main : theme.palette.grey.dark,
    },
  },
  borderRadius: 5,
  '&&&: before': {
    borderBottom: 'none',
  },
}));

export const StyledSelect = styled(Select)(({ theme, disabled }) => ({
  '&&': {
    '& fieldset': {
      borderColor: theme.palette.grey.dark, // Default border color
    },
    '&:hover fieldset': {
      borderColor: !disabled ? theme.palette.primary.main : theme.palette.grey.dark,
    },
    '&.Mui-focused fieldset': {
      borderColor: !disabled ? theme.palette.primary.main : theme.palette.grey.dark,
    },
    borderRadius: 5,
  },
}));
